import Button from "components/v2/Button/Button";
import { convertWeight, formatNumber } from "helpers/commonHelpers";

import "./Footer.scss";
import usePermissions from "hooks/usePermissions";
import { UnitSystemPreferences } from "types/Common";

type FooterProps = {
  onNextClick: () => void;
  selectedOrders: any[];
};

interface InfoItemProps {
  label: string;
  value: string | number;
  className: string;
}

// Function to calculate total weight
const getTotalWeight = (data: Array<{ total_weight_kg: string }>, unit_system_preferences: UnitSystemPreferences): number =>
  data.reduce((total, item) => {
    const weight =
      unit_system_preferences === "inch-lbs"
        ? convertWeight(item.total_weight_kg, { fromUnit: "kg", toUnit: "lbs" })
        : item.total_weight_kg;
    return total + parseFloat(weight);
  }, 0);

// Function to calculate total volume
const getTotalVolume = (data: Array<{ total_cbm: string }>): number =>
  data.reduce((total, item) => total + parseFloat(item.total_cbm), 0);

function InfoItem({ label, value, className }: InfoItemProps) {
  return (
    <div className={`footer-info-item footer-info-item__${className}`}>
      <span className="info-label text-sm text-tertiary">{label}</span>
      <span className="info-value text-md font-semibold">{value}</span>
    </div>
  );
}

function Footer({ onNextClick, selectedOrders }: FooterProps) {
  const { permissions } = usePermissions();
  const { unit_system_preferences } = JSON.parse(permissions ?? "{}");

  const footerData = [
    {
      label: "Origin",
      value: `${selectedOrders[0].pickup_address}, ${selectedOrders[0].pickup_city}`,
      className: "location",
    },
    {
      label: "Destination",
      value: `${selectedOrders[0].delivery_address}, ${selectedOrders[0].delivery_city}`,
      className: "location",
    },
    {
      label: "Total weight",
      value: `${formatNumber(getTotalWeight(selectedOrders, unit_system_preferences), 2)} ${
        unit_system_preferences === "inch-lbs" ? "lbs" : "kg"
      }`,
      className: "weight",
    },
    { label: "Volume", value: `${formatNumber(getTotalVolume(selectedOrders), 2)}m³`, className: "volume" },
  ];

  return (
    <div className="order-selection__footer d-flex align-items-center">
      <div className="order-selection__footer--inner-container">
        {footerData.map((item) => (
          <InfoItem label={item.label} value={item.value} className={item.className} />
        ))}
        <Button
          onClick={onNextClick}
          label={`Continue with ${selectedOrders.length} order${selectedOrders.length !== 1 ? "s" : ""}`}
        />
      </div>
    </div>
  );
}

export default Footer;
